<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="max-width: 95vw; width: 1400px;">
                <div class="modal-header" style="padding: 20px 30px 10px 30px;">
                    <slot name="header">
                        <div style="text-align: left;">
                            <h3 class="form-header" style="margin: 0;">Patient Administrations</h3>
                            <!-- Which register these rows are written against. It is the bag only where
                                 the bag holds stock of its own; otherwise the stock left the current
                                 location when the bag went out, and that is where the records belong. -->
                            <p style="margin: 4px 0 0 0; font-size: 0.85em; color: #666;">
                                Writing to <strong>{{ targetRegisterName }}</strong>{{ updateBalances ? '' : ' - records only, balances unchanged' }}
                            </p>
                        </div>
                        <button type="button" @click="$emit('close', true)" class="red-close-button">
                            <i class="pi pi-times" style="padding: 0;"></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body" style="max-height: 75vh; overflow-y: auto; padding: 10px 30px 20px 30px;">
                    <slot name="body">
                        <form class="action-modal">
                            
                            <!-- Top Global Section -->
                            <div style="display: flex; gap: 20px; align-items: flex-end; margin-bottom: 30px; border-bottom: 1px solid #ccc; padding-bottom: 20px;">
                                <div style="flex: 1; max-width: 250px;">
                                    <p style="text-align: left; font-weight: bold; margin-bottom: 5px;">Mission Number</p>
                                    <input type="text" v-model="missionNumber" style="width: 100%; border-radius: 4px; padding: 8px; border: 1px solid #ccc;" placeholder="Mission #..." />
                                </div>
                                <div style="flex: 1; max-width: 350px;" v-if="updateBalances">
                                    <p style="text-align: left; font-weight: bold; margin-bottom: 5px;">Bag Used <span style="color:red">*</span></p>
                                    <Dropdown
                                        v-model="selectedBag"
                                        ref="bagDropdown"
                                        @keyup="debounceSearchBag"
                                        @focus="onBagFocus"
                                        @change="bagSelected"
                                        :loading="loadingBags"
                                        :options="bagList"
                                        optionLabel="name"
                                        :editable="true"
                                        style="width: 100%;"
                                        placeholder="Select Bag"
                                    />
                                </div>
                                <!-- Off where the bag is not a register of its own: the stock left this
                                     location when the bag went out, so what was given and discarded is
                                     recorded here rather than taken off a second time. See kraken
                                     REGULATIONS.md section 1.1, "Two bag models". -->
                                <div style="flex: 1; max-width: 260px; padding-bottom: 8px;">
                                    <label style="display: flex; align-items: center; gap: 8px; cursor: pointer;">
                                        <input type="checkbox" v-model="updateBalances" style="margin: 0;" />
                                        <span style="font-weight: bold;">Update Register Balances</span>
                                    </label>
                                </div>
                            </div>

                            <!-- Patients Table -->
                            <div style="margin-bottom: 20px;">
                                <div style="display: flex; justify-content: space-between; margin-bottom: 10px; align-items: center;">
                                    <div style="display: flex; gap: 10px; align-items: center; width: 400px;">
                                        <Dropdown
                                            v-model="globalPatientSearch"
                                            ref="globalPatientDropdown"
                                            @keyup="debounceSearchGlobalPatients"
                                            @focus="onGlobalPatientFocus"
                                            @change="globalPatientSelected"
                                            :loading="loadingGlobalPatients"
                                            :options="globalPatientList"
                                            optionLabel="name"
                                            :editable="true"
                                            style="width: 100%;"
                                            placeholder="Search Existing Patient..."
                                        />
                                    </div>
                                    <p class="regular-button blue-button" style="margin: 0; cursor: pointer;" @click="addPatientRow">Add New Patient</p>
                                </div>
                                
                                <div style="overflow-x: auto; width: 100%;">
                                    <table style="width: 100%; text-align: left; border-collapse: collapse;">
                                        <thead>
                                            <tr style="border-bottom: 2px solid #ddd;">
                                                <th style="padding: 10px; font-weight: bold;">First Name <span style="color:red">*</span></th>
                                                <th style="padding: 10px; font-weight: bold;">Last Name <span style="color:red">*</span></th>
                                                <th style="padding: 10px; font-weight: bold;">Address</th>
                                                <th style="padding: 10px; font-weight: bold;">Medicare</th>
                                                <th style="padding: 10px; font-weight: bold;">DOB</th>
                                                <th style="padding: 10px; font-weight: bold;">Gender</th>
                                                <th style="padding: 10px; width: 40px;"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(row, index) in patientRows" :key="index">
                                                <tr style="background-color: #fcfcfc;">
                                                    <td style="padding: 15px 10px 5px 10px;">
                                                        <input type="text" v-model="row.firstName" style="width: 100%; min-width: 120px; border-radius: 4px; padding: 8px; border: 1px solid #ccc;" placeholder="First Name" />
                                                    </td>
                                                    <td style="padding: 15px 10px 5px 10px;">
                                                        <input type="text" v-model="row.lastName" style="width: 100%; min-width: 120px; border-radius: 4px; padding: 8px; border: 1px solid #ccc;" placeholder="Last Name" />
                                                    </td>
                                                    <td style="padding: 15px 10px 5px 10px;">
                                                        <vue-google-autocomplete
                                                            :id="'addressmap-' + index"
                                                            classname="form-control"
                                                            :placeholder="row.address || 'Search Address...'"
                                                            v-on:placechanged="(addressData, placeResultData, id) => getAddressData(addressData, placeResultData, index)"
                                                            :country="$store.state.country"
                                                            style="width: 100%; min-width: 150px; border-radius: 4px; padding: 8px; border: 1px solid #ccc;">
                                                        </vue-google-autocomplete>
                                                    </td>
                                                    <td style="padding: 15px 10px 5px 10px;">
                                                        <input type="text" v-model="row.medicare" style="width: 100%; min-width: 120px; border-radius: 4px; padding: 8px; border: 1px solid #ccc;" placeholder="Medicare" />
                                                    </td>
                                                    <td style="padding: 15px 10px 5px 10px;">
                                                        <input type="date" v-model="row.dob" style="width: 100%; min-width: 130px; border-radius: 4px; padding: 8px; border: 1px solid #ccc;" />
                                                    </td>
                                                    <td style="padding: 15px 10px 5px 10px;">
                                                        <Dropdown v-model="row.gender" :options="['Male', 'Female', 'Other', 'Unknown']"
                                                            placeholder="Select Sex" style="width: 100%; min-width: 120px;" />
                                                    </td>
                                                    <td style="padding: 15px 10px 5px 10px; text-align: center;" rowspan="2">
                                                        <button type="button" @click="removePatientRow(index)" class="red-close-button small-button" style="margin: 0 auto; display: block;">
                                                            <i class="pi pi-times" style="padding: 0;"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr style="border-bottom: 2px solid #ddd; background-color: #fcfcfc;">
                                                    <td colspan="6" style="padding: 5px 10px 15px 10px;">
                                                        <div style="display: flex; gap: 20px; align-items: center; background-color: #eef5fb; padding: 10px 15px; border-radius: 6px;">
                                                            <div style="flex: 1;">
                                                                <p style="margin: 0 0 5px 0; font-weight: 500; font-size: 0.9em; color: #555;">Administered Drug <span style="color:red">*</span></p>
                                                                <Dropdown
                                                                    v-model="row.drug"
                                                                    :ref="'drugDropdown' + index"
                                                                    @keyup="debounceSearchRowDrugs(index)"
                                                                    @focus="onRowDrugFocus(index)"
                                                                    :loading="loadingDrugs"
                                                                    :options="drugList"
                                                                    optionLabel="full_name"
                                                                    optionDisabled="disabled"
                                                                    :editable="true"
                                                                    appendTo="body"
                                                                    style="width: 100%;"
                                                                    :emptyMessage="stockPickerEmptyMessage(row.drug, 'No stock held in this bag.')"
                                                                    :placeholder="(!selectedBag || typeof selectedBag === 'string') ? 'Please select a Bag first' : 'Search / Select Drug'"
                                                                    :disabled="!selectedBag || typeof selectedBag === 'string'"
                                                                />
                                                            </div>
                                                            <div style="flex: 1;" v-if="rowHasBatches(row)">
                                                                <p style="margin: 0 0 5px 0; font-weight: 500; font-size: 0.9em; color: #555;">Batch <span style="color:red">*</span></p>
                                                                <BatchSelect :stockItem="row.drug" v-model="row.batch" />
                                                            </div>
                                                            <div style="width: 150px;">
                                                                <p style="margin: 0 0 5px 0; font-weight: 500; font-size: 0.9em; color: #555;">Admin Amount <span style="color:red">*</span></p>
                                                                <input type="number" step="0.01" v-model="row.adminAmount" style="width: 100%; border-radius: 4px; padding: 8px; border: 1px solid #ccc; background-color: white;" placeholder="e.g. 1.5" />
                                                            </div>
                                                            <div style="width: 150px;">
                                                                <p style="margin: 0 0 5px 0; font-weight: 500; font-size: 0.9em; color: #555;">Discard Amount</p>
                                                                <input type="number" step="0.01" v-model="row.discardAmount" style="width: 100%; border-radius: 4px; padding: 8px; border: 1px solid #ccc; background-color: white;" placeholder="e.g. 0.5" />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <p v-if="patientRows.length === 0" style="text-align: center; color: #666; margin-top: 20px; font-style: italic;">No patients added yet.</p>
                            </div>
                        </form>
                    </slot>
                </div>
                <p style="color: red; font-weight: 500; font-size: 1em; text-align: center; margin-top: 10px;" v-if="errorMessage">{{ errorMessage }}</p>
                
                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 15px 30px 20px 30px;">
                    <slot name="footer">
                        <p class="regular-button error-button" style="color: white; margin-right: 10px;" @click="$emit('close', true)">Cancel</p>
                        <p class="regular-button green-button" @click="initiateSignOff">
                            <i v-if="isSubmitting" class="pi pi-spin pi-spinner" style="margin-right: 5px;"></i>
                            Sign Off
                        </p>
                    </slot>
                </div>
            </div>
        </div>

        <SignatureModal
            v-if="showSignatureModal"
            @close="showSignatureModal = false"
            @isSuccessful="handleSignatureSuccess"
            :dual="requiresDoubleSig"
            :payload="realSubmit"
            endpoint="/batch-administer"
        />
        
        <SuccessModal 
            v-if="displaySuccessModal" 
            @close="$emit('close', true, 'success');" 
            :message="successMessage" 
            statusMessage="Administrations Complete" 
        />
    </div>
</template>

<script>
import axios from 'axios';
import { isPickerEmpty, pickerSearchTerm, stockPickerEmptyMessage } from '@/services/pickers';
import SignatureModal from '@/components/modals/SignatureModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';
import { debounce } from 'debounce';
import { decorateStockItems } from '@/services/stockItemDisplay';
import BatchSelect from '@/components/BatchSelect.vue';

export default {
    name: 'AmbulanceAdministrationModal',
    components: {
        BatchSelect,
        SignatureModal,
        SuccessModal
    },
    props: {
        // The bag check in these administrations belong to, when the screen was opened off the back
        // of one. Kraken records it against each administration and discard.
        checkinUuid: {
            type: String,
            default: null
        },
        // Carried over from that check in so the mission is not typed again.
        presetMissionNumber: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            missionNumber: this.presetMissionNumber || '',
            // Whether the doses and discards come off a register. On where the bag holds its own
            // stock; off where the bag is not a register and the stock already left at checkout.
            updateBalances: true,

            selectedBag: null,
            bagList: [],
            loadingBags: false,

            globalPatientSearch: null,
            globalPatientList: [],
            loadingGlobalPatients: false,
            
            drugList: [],
            loadingDrugs: false,
            
            patientRows: [],
            
            errorMessage: '',
            showSignatureModal: false,
            displaySuccessModal: false,
            successMessage: '',
            isSubmitting: false,
            realSubmit: null,
        };
    },
    computed: {
        requiresDoubleSig() {
            return this.patientRows.some(row => parseFloat(row.discardAmount) > 0);
        },
        // The location the rows are drawn from and written against.
        targetLocationUuid() {
            if (this.updateBalances) {
                return (this.selectedBag && typeof this.selectedBag !== 'string') ? this.selectedBag.uuid : null;
            }
            return this.$store.state.currentLocation ? this.$store.state.currentLocation.uuid : null;
        },
        targetRegisterName() {
            if (!this.updateBalances) {
                return this.$store.state.currentLocation ? this.$store.state.currentLocation.name : 'this location';
            }
            return (this.selectedBag && typeof this.selectedBag !== 'string') ? this.selectedBag.name : 'the selected bag';
        }
    },
    watch: {
        // The two modes read stock from different registers, so anything already picked belongs to
        // the wrong one.
        updateBalances() {
            this.clearDrugSelections();
        }
    },
    methods: {
        stockPickerEmptyMessage,
        // True when the stock chosen on this row holds batches, so one has to be picked.
        rowHasBatches(row) {
            const batches = (row && row.drug && Array.isArray(row.drug.batches)) ? row.drug.batches : [];
            // The flag is checked here too - see BatchSelect. Without it a stale response carrying
            // batches would demand a choice the screen never offers.
            return this.$store.getters.isBatchTrackingEnabled && batches.length > 0;
        },
        getAddressData(addressData, placeResultData, index) {
            let fullAddress = placeResultData.name;
            if (addressData.locality) fullAddress += ', ' + addressData.locality;
            if (addressData.administrative_area_level_1) fullAddress += ' ' + addressData.administrative_area_level_1;
            if (addressData.postal_code) fullAddress += ' ' + addressData.postal_code;
            
            if (this.patientRows[index]) {
                this.patientRows[index].address = fullAddress;
            }
        },
        searchBag(fetchDefault = false) {
            const searchTerm = pickerSearchTerm(this.selectedBag);
            if (searchTerm || fetchDefault) {
                this.loadingBags = true;
                const payload = {
                    location: searchTerm,
                    location_type: ['bag']
                };
                
                axios.post('/get-locations', payload, this.$store.state.header).then(res => {
                    let refined = [];
                    if (res.data && res.data.locations) {
                        res.data.locations.forEach(location => {
                            refined.push(location);
                        });
                    }
                    this.bagList = refined;
                    this.loadingBags = false;
                    if (this.$refs.bagDropdown) {
                        this.$refs.bagDropdown.show();
                    }
                }).catch(err => {
                    this.loadingBags = false;
                    console.error(err);
                });
            }
        },
        debounceSearchBag: debounce(function() {
            this.searchBag(false);
        }, 500),
        onBagFocus() {
            if (isPickerEmpty(this.selectedBag)) {
                this.searchBag(true);
            }
        },
        bagSelected() {
            this.clearDrugSelections();
        },
        clearDrugSelections() {
            this.drugList = [];
            this.patientRows.forEach(row => {
                row.drug = null;
                row.batch = null;
            });
        },

        searchDrugs(searchTerm, fetchDefault = false, refName = null) {
            if (!this.targetLocationUuid) return;

            if (searchTerm || fetchDefault) {
                this.loadingDrugs = true;
                const payload = {
                    drug: searchTerm,
                    location_id: this.targetLocationUuid
                };
                
                axios.post('/get-stock-items', payload, this.$store.state.header).then(res => {
                    this.drugList = decorateStockItems(res.data);
                    this.loadingDrugs = false;
                    
                    if (refName && this.$refs[refName]) {
                        let component = Array.isArray(this.$refs[refName]) ? this.$refs[refName][0] : this.$refs[refName];
                        if (component && component.show) component.show();
                    }
                }).catch(err => {
                    this.loadingDrugs = false;
                    console.error(err);
                });
            }
        },
        debounceSearchRowDrugs: debounce(function(index) {
            let row = this.patientRows[index];
            const searchTerm = pickerSearchTerm(row.drug);
            this.searchDrugs(searchTerm, false, 'drugDropdown' + index);
        }, 500),
        onRowDrugFocus(index) {
            let row = this.patientRows[index];
            if (isPickerEmpty(row.drug)) {
                this.searchDrugs('', true, 'drugDropdown' + index);
            }
        },

        searchGlobalPatients(fetchDefault = false) {
            const searchTerm = pickerSearchTerm(this.globalPatientSearch);
            
            if (searchTerm || fetchDefault) {
                this.loadingGlobalPatients = true;
                const payload = {
                    name: searchTerm,
                    location: this.$store.state.currentLocation.uuid,
                    page: 1
                };
                axios.post('/search-patients', payload, this.$store.state.header).then(res => {
                    if (res.data && res.data.patients) {
                        this.globalPatientList = res.data.patients.map(p => ({
                            uuid: p.uuid,
                            name: (p.personal_information?.first_name || '') + ' ' + (p.personal_information?.last_name || ''),
                            first_name: p.personal_information?.first_name,
                            last_name: p.personal_information?.last_name,
                            address: p.address?.address,
                            medicare: p.regulatory_information?.length ? p.regulatory_information[0].data : '',
                            dob: p.personal_information?.dob,
                            gender: p.personal_information?.gender || 'unknown'
                        }));
                    }
                    this.loadingGlobalPatients = false;
                    
                    if (this.$refs.globalPatientDropdown) {
                        this.$refs.globalPatientDropdown.show();
                    }
                }).catch(err => {
                    this.loadingGlobalPatients = false;
                    console.error(err);
                });
            }
        },
        debounceSearchGlobalPatients: debounce(function() {
            this.searchGlobalPatients(false);
        }, 500),
        onGlobalPatientFocus() {
            if (isPickerEmpty(this.globalPatientSearch)) {
                this.searchGlobalPatients(true);
            }
        },
        globalPatientSelected(event) {
            const patient = event.value;
            if (patient && patient.uuid) {
                let dobFormatted = '';
                if (patient.dob) {
                    try {
                        let d = new Date(patient.dob);
                        if (!isNaN(d)) dobFormatted = d.toISOString().split('T')[0];
                    } catch(e) {
                        console.error("Error parsing DOB:", e);
                    }
                }
                
                this.patientRows.push({
                    uuid: patient.uuid,
                    firstName: patient.first_name || '',
                    lastName: patient.last_name || '',
                    address: patient.address || '',
                    medicare: patient.medicare || '',
                    dob: dobFormatted,
                    gender: patient.gender ? (patient.gender.charAt(0).toUpperCase() + patient.gender.slice(1).toLowerCase()) : 'Unknown',
                    drug: null,
                    batch: null,
                    adminAmount: null,
                    discardAmount: null
                });
                
                // Reset global search field after selecting
                this.globalPatientSearch = null;
            }
        },

        addPatientRow() {
            this.patientRows.push({
                uuid: null,
                firstName: '',
                lastName: '',
                address: '',
                medicare: '',
                dob: '',
                gender: 'Unknown',
                drug: null,
                batch: null,
                adminAmount: null,
                discardAmount: null
            });
        },
        removePatientRow(index) {
            this.patientRows.splice(index, 1);
        },

        initiateSignOff() {
            this.errorMessage = '';
            
            // Only where the bag is the register being drawn from. With balances off there is no bag
            // to pick and the rows are written against the current location.
            if (this.updateBalances && (!this.selectedBag || typeof this.selectedBag === 'string')) {
                this.errorMessage = "Please select a valid Bag.";
                return;
            }
            if (!this.targetLocationUuid) {
                this.errorMessage = "No location to record these administrations against.";
                return;
            }
            if (this.patientRows.length === 0) {
                this.errorMessage = "Please add at least one patient administration.";
                return;
            }
            
            for (let i = 0; i < this.patientRows.length; i++) {
                const row = this.patientRows[i];
                if (!row.firstName || row.firstName.trim() === '') {
                    this.errorMessage = `Row ${i + 1}: First Name is required.`;
                    return;
                }
                if (!row.lastName || row.lastName.trim() === '') {
                    this.errorMessage = `Row ${i + 1}: Last Name is required.`;
                    return;
                }
                if (!row.drug || typeof row.drug === 'string' || !row.drug.uuid) {
                    this.errorMessage = `Row ${i + 1}: A valid drug selection is required.`;
                    return;
                }
                if (!row.adminAmount || row.adminAmount <= 0) {
                    this.errorMessage = `Row ${i + 1}: Admin Amount must be greater than 0.`;
                    return;
                }
                if (this.rowHasBatches(row) && !row.batch) {
                    this.errorMessage = `Row ${i + 1}: select the batch the dose was given from.`;
                    return;
                }
            }
            
            this.realSubmit = {
                mission_number: this.missionNumber,
                location_id: this.targetLocationUuid,
                update_balances: this.updateBalances,
                // Set when this was opened from a bag check in, so each record points at it.
                theatre_checkout_uuid: this.checkinUuid || null,
                administrations: this.patientRows.map(row => {
                    return {
                        patient: {
                            uuid: row.uuid || null,
                            first_name: row.firstName.trim(),
                            last_name: row.lastName.trim(),
                            dob: row.dob || null,
                            gender: row.gender ? row.gender.toLowerCase() : 'unknown',
                            medicare: row.medicare || null,
                            address: row.address || null
                        },
                        stock_item_uuid: row.drug.uuid,
                        // Per administration - one request carries several. The discard that follows comes
                        // off the same batch.
                        batch_uuid: row.batch ? row.batch.uuid : null,
                        qty_administered: parseFloat(row.adminAmount),
                        qty_discarded: row.discardAmount ? parseFloat(row.discardAmount) : 0
                    };
                })
            };
            
            this.showSignatureModal = true;
        },
        handleSignatureSuccess() {
            this.showSignatureModal = false;
            this.isSubmitting = false;
            this.successMessage = "Administrations successfully logged.";
            this.displaySuccessModal = true;
        }
    },
    mounted() {
        this.addPatientRow();
    }
}
</script>

<style scoped>
/* Modal styling similar to BagCheckoutModal.vue */
</style>
